import { ThemeOptions } from "@material-ui/core";

const ReadleeColors = {
  accentYellow: "#F5CE8E",
  accentRed: "#FF8066",
  functionalTan: "#EFE7DD",
  functionalBlue: "#1A73F5",
  brand: "#0091B2",
  backgroundYellow: "#FBEED9",
  tooltipBackground: "#efe7dd",
  backgroundBlue: "#D0E9F0",
};

export const defaultTheme: ThemeOptions = {
  overrides: {
    // MuiAppBar: {
    //     root: {
    //         boxShadow: '5px 5px 5px',
    //     }
    // },
    MuiButton: {
      // textSecondary: {
      //     color: 'white',
      // },
    },
    MuiTooltip: {
      tooltip: {
        color: "black",
        backgroundColor: ReadleeColors.tooltipBackground,
        borderRadius: 10,
      },
    },
    MuiSlider: {
      root: {
        color: ReadleeColors.accentYellow,
        height: 2,
        padding: "15px 0",
      },
      thumb: {
        height: 20,
        width: 20,
        backgroundColor: "#fff",

        marginTop: -10,
        marginLeft: -10,
      },
      active: {},
      valueLabel: {
        left: "calc(-50% + 12px)",
        top: -22,
        "& *": {
          background: "transparent",
          color: "#000",
        },
      },
      track: {
        height: 2,
      },
      rail: {
        height: 2,
        opacity: 0.5,
        backgroundColor: "#bfbfbf",
      },
      mark: {
        backgroundColor: "#bfbfbf",
        borderRadius: 10,
        height: 12,
        width: 12,
        marginTop: -6,
        marginLeft: -6,
      },
      markActive: {
        opacity: 1,
        backgroundColor: "currentColor",
      },
    },
  },
  palette: {
    type: "light",
    primary: {
      main: "#1a73f5",
    },
    secondary: {
      main: "#50cd82",
    },
  },
  props: {
    // MuiAppBar: {
    //     color: 'white',
    // },
    MuiToolbar: {},
  },
  typography: {
    h4: {
      color: "#ff8066",
    },
    h6: {
      color: "#f3884f",
    },
    body1: {
      color: "black",
    },
  },
};
export { ReadleeColors };
